import React from "react";

export const trendTextColor = (trend) => {
  const isUp = trend === "up" || trend === "increased" || trend === 1 || trend === "1";
  const isDown = trend === "down" || trend === "decreased" || trend === 2 || trend === "2";
  if (isUp) return "frost-text-trend-up";
  if (isDown) return "frost-text-trend-down";
  return "text-[var(--theme-text)]";
};

export const renderTrendArrow = (trend) => {
  const isUp = trend === "up" || trend === "increased" || trend === 1 || trend === "1";
  const isDown = trend === "down" || trend === "decreased" || trend === 2 || trend === "2";
  if (!isUp && !isDown) return null;
  return (
    <span
      className={[
        "ml-0.5 inline-block h-[10px] w-[10px] shrink-0",
        isUp ? "lu-odds-status--up" : "lu-odds-status--down",
      ].join(" ")}
      aria-hidden="true"
    />
  );
};

export const DesktopOddCell = ({ top, bottom, trendBottom, muted = false }) => {
  return (
    <div className="flex h-10 w-[80px] shrink-0 flex-col items-center justify-center gap-[2px] rounded-xl bg-[var(--theme-accent)] text-center">
      <div className="text-[12px] font-semibold leading-none frost-text-label-muted">
        {top ?? "\u00A0"}
      </div>
      <div
        className={[
          "flex items-center justify-center text-[14px] font-bold leading-none",
          muted ? "text-[var(--theme-text-muted)]" : trendTextColor(trendBottom),
        ].join(" ")}
      >
        <span>{bottom ?? "--"}</span>
        {!muted && renderTrendArrow(trendBottom)}
      </div>
    </div>
  );
};

export const Desktop1x2Cell = ({ label, bottom, trendBottom, muted = false }) => (
  <div className="flex h-10 w-[80px] shrink-0 flex-col items-center justify-center gap-[2px] rounded-xl bg-[var(--theme-accent)] text-center">
    <div className="text-[12px] font-semibold leading-none frost-text-label-muted">
      {label}
    </div>
    <div
      className={[
        "flex items-center justify-center text-[14px] font-bold leading-none",
        muted ? "text-[var(--theme-text-muted)]" : trendTextColor(trendBottom),
      ].join(" ")}
    >
      <span>{bottom ?? "--"}</span>
      {!muted && renderTrendArrow(trendBottom)}
    </div>
  </div>
);

export const MobileOddCell = ({ top, bottom, trendBottom, muted = false }) => {
  return (
    <div className="flex h-[54px] flex-col items-center justify-center rounded-[14px] bg-[var(--theme-accent)] leading-[1.1]">
      <div className="text-[11px] frost-text-label-muted">{top ?? "\u00A0"}</div>
      <div
        className={[
          "flex items-center justify-center text-[12px] font-semibold",
          muted ? "text-[var(--text-half-score)]" : trendTextColor(trendBottom),
        ].join(" ")}
      >
        <span>{bottom ?? "--"}</span>
        {!muted && renderTrendArrow(trendBottom)}
      </div>
    </div>
  );
};

export const Mobile1x2Cell = ({ label, bottom, trendBottom, muted = false }) => {
  return (
    <div className="flex h-[54px] flex-col items-center justify-center rounded-[14px] bg-[var(--theme-accent)] leading-[1.1]">
      <div className="text-[11px] frost-text-label-muted">{label}</div>
      <div
        className={[
          "flex items-center justify-center text-[12px] font-semibold",
          muted ? "text-[var(--text-half-score)]" : trendTextColor(trendBottom),
        ].join(" ")}
      >
        <span>{bottom ?? "--"}</span>
        {!muted && renderTrendArrow(trendBottom)}
      </div>
    </div>
  );
};
